import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function FitnessConditioning() {
  return <section className="py-24 bg-off-white" data-id="element-1394">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1395">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-1396">
          <div data-id="element-1397">
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1398">
              The Unique Conditioning of Taekwondo
            </h2>
            <p className="text-lg text-gray-warm mb-8" data-id="element-1399">
              While all martial arts offer fitness benefits, Taekwondo is
              especially renowned for its dynamic kicking techniques. This focus
              creates specific, powerful physical adaptations.
            </p>
            <ul className="space-y-4" data-id="element-1400">
              {['Exceptional leg strength and explosive power', 'Deep core engagement for balance and rotation', 'High-level agility and quick directional changes', 'Superior flexibility in the hips and hamstrings', 'Intense aerobic and anaerobic conditioning'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-1401">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-1402" />
                  <span className="text-lg text-ink" data-id="element-1403">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="relative" data-id="element-1404">
            <div className="aspect-square rounded-full bg-storm-red/5 absolute -inset-4 z-0" data-id="element-1405" />
            <img src={SITE_IMAGES.adultClasses} alt="Taekwondo conditioning" className="block relative z-10 rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-1406" />
          </div>
        </div>
      </div>
    </section>;
}